export function whenDefined<T, U>(
  value: T | undefined,
  mutation: (value: T) => U
): U | undefined {
  return value ? mutation(value) : undefined;
}

export function isAbortError(error: unknown): error is Error {
  return (
    (error instanceof DOMException && error.name === 'AbortError') ||
    (error instanceof Error && error.name === 'AbortError')
  );
}

/**
 * Safely parses an ID from a string, handling edge cases like NaN, empty strings, and whitespace.
 *
 * @param id - The ID string to parse
 * @returns A valid integer or undefined if the input is invalid
 */
export const parseId = (id: string | undefined): number | undefined => {
  if (!id) {
    return undefined;
  }

  const trimmed = id.trim();
  if (trimmed === '') {
    return undefined;
  }

  const parsed = parseInt(trimmed, 10);
  if (!Number.isFinite(parsed)) {
    return undefined;
  }

  return parsed;
};

export const isDev = process.env.NODE_ENV === 'development';
